<template>
    <div class="menu">
        <v-navigation-drawer app v-model="drawer" fixed bottom persistent>
            <v-list nav dense>
                <v-list-item-title class="px-2 mt-2" align="center">
                    <img :src="icon" width="160" style="cursor:pointer;" @click="$router.push({name: 'Home'})" alt="iNOC V2"/>
                </v-list-item-title>
                <p></p>
                <v-divider></v-divider>
                <v-list-item-group v-model="group" color="accent" class="pt-2">
                    <v-list-item to="/">
                        <v-list-item-icon>
                            <v-icon>mdi-home</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>Home</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-item-group>


                <v-list-group :value="menu.name === 'Reports'" class="pt-2" v-for="menu in menus" :key="menu.name" prepend-icon="mdi-chart-box">
                    <template v-slot:activator>
                        <v-list-item-title>{{menu.name}}</v-list-item-title>
                    </template>

                    <v-list-item v-for="menuItem in menu.menuItems" :to="menuItem.link" :key="menuItem.name" link>

                        <v-list-item-icon>
                            <v-icon>mdi-circle-small</v-icon>
                        </v-list-item-icon>

                        <v-list-item-title>{{menuItem.name}}</v-list-item-title>
                    </v-list-item>

                </v-list-group>


                <v-list-group :value="false" class="pt-2" v-if="isAdmin" prepend-icon="mdi-cog-box">
                    <template v-slot:activator>
                        <v-list-item-title>Administrator</v-list-item-title>
                    </template>

                    <v-list-item to="/chartcolumns" link>
                        <v-list-item-icon>
                            <v-icon>mdi-circle-small</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Chart Columns</v-list-item-title>
                    </v-list-item>

                    <v-list-item to="/reportbuilder" link>
                        <v-list-item-icon>
                            <v-icon>mdi-circle-small</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Report Builder</v-list-item-title>
                    </v-list-item>

                    <v-list-item to="/users" link>
                        <v-list-item-icon>
                            <v-icon>mdi-circle-small</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Users</v-list-item-title>
                    </v-list-item>

                    <v-list-item to="/operators" link>
                        <v-list-item-icon>
                            <v-icon>mdi-circle-small</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Operators</v-list-item-title>
                    </v-list-item>

                    <v-list-item to="/helpguides">
                        <v-list-item-icon>
                            <v-icon>mdi-circle-small</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Help Guides</v-list-item-title>
                    </v-list-item>

                    <v-list-item to="/helpCaptions">
                        <v-list-item-icon>
                            <v-icon>mdi-circle-small</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Help Captions</v-list-item-title>
                    </v-list-item>

                    <v-list-item to="/sensitivenamemanagement">
                        <v-list-item-icon>
                            <v-icon>mdi-circle-small</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Sensitive Name Management</v-list-item-title>
                    </v-list-item>

                </v-list-group>

                <v-list-item-group v-model="group" color="accent" class="pt-2">
                    <v-list-item to="/chartbuilder">
                        <v-list-item-icon>
                            <v-icon>mdi-chart-arc</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>Chart Builder</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-item-group>
                <v-list-item-group v-model="group" color="accent" class="pt-2">
                    <v-list-item to="/mycharts">
                        <v-list-item-icon>
                            <v-icon>mdi-chart-timeline-variant-shimmer</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>My Charts</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-item-group>
                <v-list-item-group v-model="group" color="accent" class="pt-2">
                    <v-list-item to="/help">
                        <v-list-item-icon>
                            <v-icon>mdi-help-box</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>Help</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-item-group>

            </v-list>
        </v-navigation-drawer>

        <v-app-bar app dense>
            <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
            <v-toolbar-title>
                <img class="pt-2" :src="icon" width="70" style="cursor:pointer;"  @click="$router.push({name: 'Home'})" alt="iNOC V2"/>
            </v-toolbar-title>
            <v-spacer></v-spacer>

            <div v-if="authState.isAuthenticated">
                {{claims && claims.email}}
            </div>

            <div class="pl-5">
                <v-tooltip v-if="!$vuetify.theme.dark" bottom>
                    <template v-slot:activator="{  }">
                        <v-icon class="mr-1" @click="onChangeTheme">mdi-moon-waxing-crescent</v-icon>
                    </template>
                    <span>Dark Mode On</span>
                </v-tooltip>

                <v-tooltip v-else bottom>
                    <template v-slot:activator="{  }">
                        <v-icon color="yellow" @click="onChangeTheme">mdi-white-balance-sunny</v-icon>
                    </template>
                    <span>Dark Mode Off</span>
                </v-tooltip>
            </div>
        </v-app-bar>
    </div>
</template>

<script>
    import { EventBus } from '../../event/event-bus.js';
    import config from '../../../public/okta.config.json';
    import * as am4core from "@amcharts/amcharts4/core";
    import am4themes_animated from "@amcharts/amcharts4/themes/animated";
    import MenuService from "../../services/menuService"

    export default {
        data: function () {
            return {
                accessToken: '',
                claims: '',
                drawer: false,
                group: null,
                icon: require('../../../public/logo.svg'),
                isAdmin: false,
                menus: []
            }
        },
        watch: {
            group() {
                this.drawer = false;
            },
        },
        methods: {
            async setup() {


                this.accessToken = this.$auth.getAccessToken();
                if (this.authState.isAuthenticated) {
                    this.claims = await this.$auth.getUser();
                }

                var user = await this.$auth.getUser();
                this.isAdmin = user.groups.includes(config.adminGroup);

                const isThemeDark = localStorage.getItem("theme-dark");

                if (isThemeDark) {
                    this.$vuetify.theme.dark = isThemeDark === "true";
                }

                am4core.useTheme(am4themes_animated);
                am4core.useTheme(this.am4themes_myTheme);

                //reason for timeout this will be pushed onto browser javascript runtime queue that will optimise the theme change
                setTimeout(() => {
                    EventBus.$emit('emit-theme-change', this.$vuetify.theme.dark);
                }, 8);

                await this.getOperatorMenus();
            },
            async getOperatorMenus() {
                this.menus = await MenuService.getOperatorMenus(this.accessToken);
            },
            onChangeTheme() {
                this.$vuetify.theme.dark = !this.$vuetify.theme.dark;

                localStorage.setItem("theme-dark", this.$vuetify.theme.dark);

                am4core.useTheme(am4themes_animated);
                am4core.useTheme(this.am4themes_myTheme);

                //reason for timeout this will be pushed onto queue that will optimise the theme change prioritizing ui thread to load first
                setTimeout(() => {
                    EventBus.$emit('emit-theme-change', this.$vuetify.theme.dark);
                }, 8);
            },
            am4themes_myTheme(target) {
                if (target instanceof am4core.InterfaceColorSet) {

                    const theme = this.$vuetify.theme.themes[this.$vuetify.theme.dark === true ? "dark" : "light"];
                    const textColor = this.$vuetify.theme.dark === true ? "#fff" : "#000";
                    const background = this.$vuetify.theme.dark === true ? "#000" : "#fff";

                    target.setFor("primaryButton", am4core.color(theme.primary));
                    target.setFor("primaryButtonHover", am4core.color(theme.primary).lighten(-0.2));
                    target.setFor("primaryButtonDown", am4core.color(theme.primary).lighten(-0.2));
                    target.setFor("primaryButtonActive", am4core.color(theme.primary).lighten(-0.2));
                    target.setFor("primaryButtonText", am4core.color(textColor));
                    target.setFor("primaryButtonStroke", am4core.color(theme.primary));

                    target.setFor("secondaryButton", am4core.color(theme.primary));
                    target.setFor("secondaryButtonHover", am4core.color(theme.primary).lighten(-0.2));
                    target.setFor("secondaryButtonDown", am4core.color(theme.primary).lighten(-0.2));
                    target.setFor("secondaryButtonActive", am4core.color(theme.primary).lighten(-0.2));
                    target.setFor("secondaryButtonText", am4core.color(textColor));
                    target.setFor("secondaryButtonStroke", am4core.color(theme.primary));

                    target.setFor("alternativeBackground", am4core.color(theme.primary));
                    target.setFor("background", am4core.color(background));

                    target.setFor("text", am4core.color(textColor));
                    target.setFor("fill", am4core.color(theme.primary));
                    target.setFor("grid", am4core.color(textColor));
                }

                if (target instanceof am4core.ColorSet) {
                    target.list = [
                        am4core.color("#aad2ed"),
                        am4core.color("#8e5ea2"),
                        am4core.color("#3cba9f"),
                        am4core.color("#ad010f"),
                        am4core.color("#f79c40"),
                        am4core.color("#365b87"),
                        am4core.color("#bf9bcf"),
                        am4core.color("#8fad89"),
                        am4core.color("#f990a7"),
                        am4core.color("#948701")
                    ];
                }
            }
        },
        created() {
            this.setup();
        }
    }
</script>
